module.exports = __webpack_public_path__ + "img/icon-default.a7fa79e8.svg";